import { FAILURE, REQUEST, SUCCESS } from 'utils/actionTypeUtil';

import { API_URL } from 'constants/apiUrl';
import axios from 'axios';

const apiUrl = `${API_URL}/classroom_article`;

export const ACTION_TYPES = {
  FETCH_CLASSROOM_ARTICLE_LIST: 'CLASSROOM_ARTICLE/FETCH_CLASSROOM_ARTICLE_LIST',
  FETCH_CLASSROOM_ARTICLE: 'CLASSROOM_ARTICLE/FETCH_CLASSROOM_ARTICLE',
  CREATE_CLASSROOM_ARTICLE: 'CLASSROOM_ARTICLE/CREATE_CLASSROOM_ARTICLE',
  UPDATE_CLASSROOM_ARTICLE: 'CLASSROOM_ARTICLE/UPDATE_CLASSROOM_ARTICLE',
  DELETE_CLASSROOM_ARTICLE: 'CLASSROOM_ARTICLE/DELETE_CLASSROOM_ARTICLE',
  RESET: 'CLASSROOM_ARTICLE/RESET',
};

const initial = {
  loading: false,
  errorMessage: null,
  updating: false,
  updateSuccess: false,
  entities: [], //ent
  entity: {}, //defaultValue
  pageable: {
    sort: {
      sorted: false,
      unsorted: true,
      empty: true,
    },
    pageSize: 10,
    pageNumber: 0,
    offset: 0,
    paged: true,
    unpaged: false,
  },
  totalElements: 0,
  last: false,
  totalPages: 0,
  sort: {},
  first: true,
  numberOfElements: 0,
  size: 0,
  number: 0,
  empty: true,
};

// REDUCER
const classroomArticleReducer = (state = initial, action) => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_CLASSROOM_ARTICLE_LIST):
    case REQUEST(ACTION_TYPES.FETCH_CLASSROOM_ARTICLE):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_CLASSROOM_ARTICLE):
    case REQUEST(ACTION_TYPES.UPDATE_CLASSROOM_ARTICLE):
    case REQUEST(ACTION_TYPES.DELETE_CLASSROOM_ARTICLE):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_CLASSROOM_ARTICLE_LIST):
    case FAILURE(ACTION_TYPES.FETCH_CLASSROOM_ARTICLE):
    case FAILURE(ACTION_TYPES.CREATE_CLASSROOM_ARTICLE):
    case FAILURE(ACTION_TYPES.UPDATE_CLASSROOM_ARTICLE):
    case FAILURE(ACTION_TYPES.DELETE_CLASSROOM_ARTICLE):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload.response,
      };
    case SUCCESS(ACTION_TYPES.FETCH_CLASSROOM_ARTICLE_LIST):
      let res = action.payload.data;
      return {
        ...state,
        loading: false,
        entities: res.content,
        pageable: {
          sort: {
            sorted: res.pageable.sort.sorted,
            unsorted: res.pageable.sort.unsorted,
            empty: res.pageable.sort.empty,
          },
          pageSize: res.pageable.page_size,
          pageNumber: res.pageable.page_number,
          offset: res.pageable.offset,
          paged: res.pageable.paged,
          unpaged: res.pageable.unpaged,
        },
        totalElements: res.total_elements,
        last: res.last,
        totalPages: res.total_pages,
        sort: res.sort,
        first: res.first,
        numberOfElements: res.number_of_elements,
        size: res.size,
        number: res.number,
        empty: res.empty,
      };
    case SUCCESS(ACTION_TYPES.FETCH_CLASSROOM_ARTICLE):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_CLASSROOM_ARTICLE):
    case SUCCESS(ACTION_TYPES.UPDATE_CLASSROOM_ARTICLE):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
        successMessage: action.payload.meta,
      };
    case SUCCESS(ACTION_TYPES.DELETE_CLASSROOM_ARTICLE):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return { ...initial };
    default:
      return state;
  }
};

export default classroomArticleReducer;

// ACTIONS
export const getEntities = (page, size, sort) => ({
  type: ACTION_TYPES.FETCH_CLASSROOM_ARTICLE_LIST,
  payload: axios.get(apiUrl, {
    params: {
      page: undefined || page,
      size: undefined || size,
      sort: undefined || sort,
    },
  }),
});

export const getEntity = id => ({
  type: ACTION_TYPES.FETCH_CLASSROOM_ARTICLE,
  payload: axios.get(`${apiUrl}/${id}`),
});

export const createEntity = (entity, courseId) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_CLASSROOM_ARTICLE,
    payload: axios.post(apiUrl, entity),
    meta: { successMessage: `Berhasil simpan!` },
  });
  dispatch(getEntitiesByCourseId(courseId,null,10,null));
  return result;
};

export const updateEntity = (entity, id, courseId) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_CLASSROOM_ARTICLE,
    payload: axios.patch(`${apiUrl}/${id}`, entity),
    meta: { successMessage: `Berhasil update!` },
  });
  dispatch(getEntitiesByCourseId(courseId,null,10,null));
  return result;
};

export const deleteEntity = (id, courseId, page, sort) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_CLASSROOM_ARTICLE,
    payload: axios.delete(`${apiUrl}/${id}`),
    meta: { successMessage: `Berhasil hapus!` },
  });
  dispatch(getEntitiesByCourseId(courseId,page,10,sort));
  return result;
};

export const getArticleByClass = id => ({
  type: ACTION_TYPES.FETCH_CLASSROOM_ARTICLE,
  payload: axios.get(`${apiUrl}/classroom/${id}`),
});

export const getEntitiesByCourseId = (id, page, size, sort) => ({
  type: ACTION_TYPES.FETCH_CLASSROOM_ARTICLE_LIST,
  payload: axios.get(`${apiUrl}/course/${id}`, {
    params: {
      page: undefined || page,
      size: undefined || size,
      sort: undefined || sort,
    },
  }),
});

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
